
import { useEffect } from 'react';
import store from './app/redux/store';
import { Provider } from 'react-redux';
import AppRouter from './app/navigation';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline, GlobalStyles } from '@mui/material';
import { AppContextProvider } from './context/AppContext';
import { setupInterceptors } from './app/redux/axiosInstance';
import './App.css';


const GlobalStylesOverride = () => (
  <GlobalStyles
    styles={{
      body: {
        '-webkit-font-smoothing': 'antialiased', // Improves WebKit browser rendering
        '-moz-osx-font-smoothing': 'grayscale', // Improves macOS rendering
        'text-rendering': 'optimizeLegibility', // Optimizes for better legibility
      },
    }}
  />
);

// const theme = createTheme({
//   typography: {
//     fontFamily: '" Helvetica Neue", Helvetica, Arial, sans- serif',
//     fontWeightMedium: '800',
//     fontWeightBold: 'bold',
//     fontWeightRegular: '500'
//   }, components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           cursor: 'pointer',
//         },
//       },
//     }
//   },
// });

const theme = createTheme({
  typography: {
    fontFamily: '"Titillium Web", sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          cursor: 'pointer',
        },
      },
    },
  },
});

function App() {
  useEffect(() => {
    console.log("Running in Environment:", process.env.REACT_APP_ENVIRONMENT);
    setupInterceptors();
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <CssBaseline />
        <GlobalStylesOverride />
        <AppContextProvider>
          <AppRouter />
        </AppContextProvider>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
